import type { IconSvgObject } from './types';

const HandPointingRight01Icon: IconSvgObject = [
  ["path", { d: "M2 18H4L6.31081 18.9985C7.78747 19.7056 10.6774 20.6732 12.0382 19.3211C14.1833 17.1895 14.576 14.2082 14.5 12.5H20.25C21.2165 12.5 22 11.7165 22 10.75C22 9.7835 21.2165 9 20.25 9L10 9L12.3287 6.78341C12.9689 6.05938 12.8628 4.96519 12.0947 4.36948C11.4556 3.87385 10.5466 3.87719 9.91137 4.3775L4.00268 9H2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default HandPointingRight01Icon;
